import { render, staticRenderFns } from "./AppSnackbar.vue?vue&type=template&id=41ca7d74&"
import script from "./AppSnackbar.vue?vue&type=script&lang=ts&"
export * from "./AppSnackbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/backoffice-legado-frontend/backoffice-legado-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41ca7d74')) {
      api.createRecord('41ca7d74', component.options)
    } else {
      api.reload('41ca7d74', component.options)
    }
    module.hot.accept("./AppSnackbar.vue?vue&type=template&id=41ca7d74&", function () {
      api.rerender('41ca7d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppSnackbar.vue"
export default component.exports